<template>
  <span class="status-pill" :class="`status-pill--${variant}`">
    <span class="status-pill__dot"></span>
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
export default {
  name: 'status-pill',
  props: {
    variant: {
      type: String,
      required: true,
      validator: (v) => ['progress', 'success', 'critical', 'neutral'].includes(v),
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px 4px 8px;
  border-radius: var(--radius-pill);
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.status-pill__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: none;
}
.status-pill--progress { background: var(--gold-soft); color: var(--gold-dark); }
.status-pill--progress .status-pill__dot { background: var(--gold-dark); }
.status-pill--success { background: var(--brand-soft); color: var(--brand-dark); }
.status-pill--success .status-pill__dot { background: var(--brand-dark); }
.status-pill--critical { background: var(--critical-soft); color: var(--critical); }
.status-pill--critical .status-pill__dot { background: var(--critical); }
.status-pill--neutral { background: var(--stop-soft); color: var(--stop); }
.status-pill--neutral .status-pill__dot { background: var(--stop); }
</style>
